import React from 'react'
import FollowUp from './FollowUp';
import {View} from '../../app-components';

export default {
  'follow-up': {
    renderHeader: () => {
      return (
        <View
          style={{
            height: 1,
            marginTop: 5,
            width: '100%',
            backgroundColor: 'rgb(151,151,151, 0.34)',
          }}
        />
      );
    },
    screen: FollowUp,
  },
};
